exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.top-spacer[data-v-32c95b2a]{position:absolute;bottom:0;left:0;-webkit-transform:translate(-6%, 15.5px);transform:translate(-6%, 15.5px);width:100vw;height:20px;z-index:5;background-color:#fff\n}", "", {"version":3,"sources":["/newvolume/workspace/integ/UI/lili-ui-partners-deploy/src/components/welcomeComponents/TopContent.vue"],"names":[],"mappings":";AAuCA,6BACE,kBACA,SACA,OACA,yCAAA,iCACA,YACA,YACA,UACA,qBAAA;CAAA","file":"TopContent.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.top-spacer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  transform: translate(-6%, 15.5px);\n  width: 100vw;\n  height: 20px;\n  z-index: 5;\n  background-color: rgb(255, 255, 255);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32c95b2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/welcomeComponents/TopContent.vue
// module id = 99fW
// module chunks = 28